// 新版打包vuex
const newPack = {
    state: {
      goodsSelectorVisible: false,
      scanContent: '',
      goodsList: [],
      selectedGoods: [],
      packMachineNo: '', // 打包台号
      shipContainerNo: '', // 发货容器号
      containerNo: '', // 拣货容器号/rebin墙号
      packTypeNo: 1, // 打包类型，1复合打包 2独立打包
      shippingContainerNoFlag: false, // 发货容器号开关
      obCheckCM: {}, // 复核打包返回
      checkMR: {}, // 独立打包返回
      explosiveCheckMR: {}, // 爆品复核返回
      leftZoneOpen: ['1'], // 默认打开基础信息
      showConsCodeInput: false,
      printPaperInfo: [],
      showWaybillDialog: false,
      isPrintTransPlanCode: true,
      shipByFreezeBox: false, // 发货容器是否是保温箱
      freezeBoxSize: {}, // 保温箱尺寸
      continuePackageList: [], // 子不语继续打包列表，理论上只能有一个值
      showAssistantDialog: false, // 辅助人绑定弹窗
      assistantList: [], // 已绑定辅助人列表
      showUnCodeLabelTipsDialog: false,
      unCodeLabelList: [],
      palletNoBinded: '', // 打包台绑定的托号，自动拆托场景
    },
    getters: {
      goodsSelectorVisible: state => state.goodsSelectorVisible,
      scanContent: state => state.scanContent,
      goodsList: state => state.goodsList,
      selectedGoods: state => state.selectedGoods,
      packTypeNo: state => state.packTypeNo,
      packMachineNo: state => state.packMachineNo,
      shipContainerNo: state => state.shipContainerNo,
      containerNo: state => state.containerNo,
      shippingContainerNoFlag: state => state.shippingContainerNoFlag,
      obCheckCM: state => state.obCheckCM,
      checkMR: state => state.checkMR,
      leftZoneOpen: state => state.leftZoneOpen,
      showConsCodeInput: state => state.showConsCodeInput,
      printPaperInfo: state => state.printPaperInfo,
      showWaybillDialog: state => state.showWaybillDialog,
      isPrintTransPlanCode: state => state.isPrintTransPlanCode,
      shipByFreezeBox: state => state.shipByFreezeBox,
      freezeBoxSize: state => state.freezeBoxSize,
      continuePackageList: state => state.continuePackageList,
      showAssistantDialog: state => state.showAssistantDialog,
      assistantList: state => state.assistantList,
      showUnCodeLabelTipsDialog: state => state.showUnCodeLabelTipsDialog,
      unCodeLabelList: state => state.unCodeLabelList,
      palletNoBinded: state => state.palletNoBinded
    },
    mutations: {
      SET_GOODS_SELECTOR_VISIBLE(state, payload) {
        state.goodsSelectorVisible = payload
      },
      SET_SCAN_CONTENT(state, payload) {
        state.scanContent = payload
      },
      SET_GOODS_LIST(state, payload) {
        state.goodsList = payload
      },
      SET_SELECTED_GOODS(state, payload) {
        state.selectedGoods = payload
      },
      SET_PACK_MACHINE_NO(state, payload) {
        state.packMachineNo = payload
      },
      SET_SHIP_CONTAINER_NO(state, payload) {
        state.shipContainerNo = payload
      },
      SET_CONTAINER_NO(state, payload) {
        state.containerNo = payload
      },
      SET_SHIPPING_CONTAINER_NO_FLAG(state, payload) {
        state.shippingContainerNoFlag = payload
      },  
      SET_PACK_TYPE_NO(state, payload) {
        state.packTypeNo = payload
      },
      SET_OPEN_INDEX(state, payload) {
        state.leftZoneOpen = payload
      },
      SET_OB_CHECK_CM(state, payload) {
        state.obCheckCM = payload
      },
      SET_CHECK_MR(state, payload) {
        state.checkMR = payload
      },
      SET_CONS_CODE_INPUT_SHOW(state, payload) {
        state.showConsCodeInput = payload
      },
      SER_PRINT_PAPER_INFO(state, payload) {
        state.printPaperInfo = payload
      },
      SET_WAYBILL_DIALOG_SHOW(state, payload) {
        state.showWaybillDialog = payload
      },
      SET_EXPLOSIVE_CHECK_MR(state, payload) {
        state.explosiveCheckMR = payload
      },
      HANDLE_GOODS_CONFIRM(state) {
        return state.selectedGoods.length === 1
      },
      RESET_GOODS_SELECTOR(state) {
        state.goodsSelectorVisible = false
        state.scanContent = ''
        state.goodsList = []
        state.selectedGoods = []
      },
      SET_PRINT_TRANS_CODE_SWITCH(state, payload) {
        state.isPrintTransPlanCode = payload
      },
      SET_FREEZE_BOX_FLAG(state, payload) {
        state.shipByFreezeBox = payload
      },
      SET_FREEZE_BOX_SIZE(state, payload) {
        state.freezeBoxSize = payload
      },
      SET_CONTINUE_PACKAGE_NO(state, payload) {
        state.continuePackageList = payload
      },
      SET_ASSISTANT_DIALOG_SHOW(state, payload) {
        state.showAssistantDialog = payload
      },
      SET_ASSISTANT_LIST(state, payload) {
        state.assistantList = payload
      },
      SET_UNCODE_LABEL_DIALOG_SHOW(state, payload) {
        state.showUnCodeLabelTipsDialog = payload
      },
      SET_UNCODE_LABEL_LIST(state, payload) {
        state.unCodeLabelList = payload
      },
      SET_BINDED_PALLET_NO(state, payload) {
        state.palletNoBinded = payload
      }
    }
  }
  
  export default newPack
